/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_SalutationInputs */

const en__field_salutation = /** @type {(inputs: _Field_SalutationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salutation`)
};

const de__field_salutation = /** @type {(inputs: _Field_SalutationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anrede`)
};

/**
* | output |
* | --- |
* | "Salutation" |
*
* @param {_Field_SalutationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_salutation = /** @type {((inputs?: _Field_SalutationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_SalutationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_salutation(inputs)
	return de__field_salutation(inputs)
});